import { render, staticRenderFns } from "./DoubleClockRange.vue?vue&type=template&id=3188e78e&lang=pug"
import script from "./DoubleClockRange.vue?vue&type=script&lang=js"
export * from "./DoubleClockRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports